import {
  Button,
  Container,
  Grid,
  LoadingOverlay,
  Menu,
  Modal,
  Notification,
  Select,
  TextInput,
} from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import { IconCheck, IconLogout, IconX } from "@tabler/icons";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import profileMale from "../../assets/male.png";
import LabtestService from "../../services/LabtestService";
import StorageService from "../../services/StorageService";
import "../../style/dashboard.css";

const labtestService = new LabtestService();
const storageService = new StorageService();

export const NotificationStyles = {
  position: "fixed",
  left: "0",
  bottom: "40px",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
} as React.CSSProperties;

function NewDashboard() {
  const [searchStatus, setSearchStatus] = React.useState<string>("1");
  let [countryCode, setCountryCode] = React.useState<string>("91");

  const [searchString, setSearchString] = React.useState<string>("");
  const [openLabtest, setLabtestOpen] = React.useState<boolean>(false);
  const [error, setError] = React.useState("");
  const [appointmentSuccess, setAppointmentSuccess] = React.useState(false);
  const checkAuthSorage = () => {
    let result = false;
    let tok = storageService.get("token");
    if (tok === null) {
      result = true;
    }
    return result;
  };
  const [loading, setLoading] = React.useState<boolean>(checkAuthSorage());

  const [logOut, setLogout] = React.useState<boolean>(false);
  const [searchlist, setSearchlist] = React.useState("");

  let navigate = useNavigate();

  useEffect(() => {
    if (logOut) {
      storageService.clearAll();
      window.location.reload();
      window.location.reload();
    }
  }, [logOut]);

  const searchPatient = () => {
    let onResponse = (data: any) => {
      setLoading(false);
      setLabtestOpen(true);
    };
    let onError = () => {
      setLoading(false);
      showNotification({
        title: "No Patient found",
        message: "",
        color: "red",
      });
    };

    labtestService.searchPatient(
      searchStatus,
      searchString,
      onResponse,
      onError,
    );
  };

  const logoutBtn = () => {
    let phoneNo = storageService.get("phone_no");
    return (
      <Menu shadow="md" width={200}>
        <Menu.Target>
          <div className="log-out-Button">
            <div style={{ alignSelf: "center" }}>
              <img
                className="profile-icon"
                width={"40px"}
                height={"40px"}
                src={profileMale}
                alt={"user profile"}
              />
              <label className="profile-label"> {phoneNo}</label>
              {/* <IconMoodSmile className="profile-icon"></IconMoodSmile>{" "} */}
            </div>
          </div>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Item
            onClick={(e: any) => {
              setLoading(true);
              logout(e);
            }}
          >
            <IconLogout></IconLogout>{" "}
            <label className="icon-log-out">{"Log Out"}</label>
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    );
  };
  const logout = (e: any) => {
    e.preventDefault();
    storageService.clearAll();

    setTimeout(() => {
      setLogout(true);
    }, 1000);
  };

  const closeModal = () => {
    setLabtestOpen(false);
  };
  return (
    <Container>
      {!logOut && (
        <Grid className="first-row-dashboard">
          <Grid.Col span={12}>
            <label className="dashboard-heading">
              <h1>{"Patients"}</h1>
            </label>
          </Grid.Col>
        </Grid>
      )}
      {!logOut && (
        <Grid className="search-bar-dashboard">
          <Grid.Col span={2}>
            <Select
              className="dropdown-dashboard"
              data={[
                { value: "1", label: "Id" },
                // { value: "2", label: "Phone No" },
              ]}
              onChange={(val) => {
                let valstr = "";
                valstr = val as string;
                setSearchStatus(valstr);
              }}
              value={searchStatus}
            />
          </Grid.Col>
          {searchStatus === "2" && (
            <Grid.Col span={2}>
              <Select
                className="dropdown-dashboard"
                data={[
                  { value: "91", label: "India 91" },
                  { value: "97", label: "Dubai 97" },
                ]}
                onChange={(val) => {
                  let valstr = "";
                  valstr = val as string;
                  setCountryCode(valstr);
                }}
                value={countryCode}
              />
            </Grid.Col>
          )}

          <Grid.Col span={searchStatus === "1" ? 8 : 8}>
            <TextInput
              type="number"
              value={searchString}
              onChange={(val) => {
                let valstr = "";
                valstr = val.target.value as string;
                setSearchString(valstr);
                setSearchlist(valstr);
              }}
              placeholder={
                searchStatus === "1"
                  ? "Type ID to search"
                  : "Seach Phone Number"
              }
            />
          </Grid.Col>
          <LoadingOverlay visible={loading} overlayBlur={2} />
          <Grid.Col span={2} className="padding-zero">
            <Button
              className="search-button"
              onClick={() => {
                if (
                  Number.isInteger(Number(searchString)) &&
                  Number(searchString) > 0
                ) {
                  setLoading(true);
                  searchPatient();
                  setSearchlist(searchString);
                }
              }}
            >
              SEARCH
            </Button>
          </Grid.Col>
        </Grid>
      )}
      {!logOut && (
        <Grid>
          <Grid.Col span={2} className="padding-zero">
            {logoutBtn()}
          </Grid.Col>
        </Grid>
      )}
      {logOut && (
        <Grid className="first-row-dashboard" style={{ textAlign: "center" }}>
          <Grid.Col span={12}>
            <label className="dashboard-heading">
              <h1> Logging Out..</h1>
            </label>
          </Grid.Col>
        </Grid>
      )}

      {appointmentSuccess && (
        <div style={NotificationStyles}>
          <Notification
            icon={<IconCheck size={18} />}
            color="teal"
            title="Appointment created."
            onClose={() => setAppointmentSuccess(false)}
          ></Notification>
        </div>
      )}

      {error !== "" && (
        <div style={NotificationStyles}>
          <Notification
            title="Cannot create appointment"
            icon={<IconX size={18} />}
            color="red"
            onClose={() => setError("")}
          >
            {error}
          </Notification>
        </div>
      )}

      <Modal
        size="lg"
        centered
        style={{ position: "fixed" }}
        opened={openLabtest}
        onClose={() => {
          closeModal();
        }}
      >
        <Button
          style={{
            marginLeft: "15px",
            height: "50px",
            width: "250px",
            backgroundColor: "#ef7c01",
            fontSize: "16px",
            marginRight: "50px",
          }}
          onClick={() => {
            setLoading(false);
            navigate(`/create?id=${searchString}`);
            setLabtestOpen(false);
          }}
        >
          Create new appointment
        </Button>
        <Button
          style={{
            height: "50px",
            width: "250px",
            backgroundColor: "#ef7c01",
            fontSize: "16px",
          }}
          onClick={() => {
            setLoading(false);
            navigate(`/view?id=${searchString}`);
            setLabtestOpen(false);
          }}
        >
          View past appointments
        </Button>
      </Modal>
    </Container>
  );
}

export default NewDashboard;
